<template>
	<v-app id='catalog-vue-app'>
		<v-main class='my-6 max-width-container'>

			<loading-spinner v-if='loading' text='Katalog wird geladen, bitte warten...' class='pb-16 px-16 mx-4' />

			<catalog-desktop v-else-if='$vuetify.breakpoint.lgAndUp' class='hidden-md-and-down' />
			<catalog-mobile v-else class='hidden-lg-and-up' />

			<v-dialog
				v-model='errorDialog.show'
				persistent
				width='539px'
			>
				<v-card>
					<v-toolbar
						class='no-text-highlight font-weight-bold'
						color='error'
						dark
						flat
					>
						<v-toolbar-title style='font-size: 17px !important;'>
							Ein Fehler ist aufgetreten
						</v-toolbar-title>
					</v-toolbar>
					<v-card-text class='ma-0 py-8'>
						<p v-if='errorDialog.text' style='font-size: 15px;'>
							Folgender Fehler ist aufgetreten: <b>{{ errorDialog.text }}</b>
							URL: {{ errorDialog.url }}
						</p>
						<div style='font-size: 16px;' class='font-weight-bold'>
							Bitte laden Sie die Seite neu.
						</div>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn
							color='error'
							text
							@click='reload()'
						>
							Zurück zur Startseite
							<v-icon class='ml-2' size='18'>
								fas fa-redo-alt
							</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<search-order-manager-dialog :search-order-id='searchOrderId' />
		</v-main>
	</v-app>
</template>

<script>
import CatalogDesktop from '@/components/CatalogDesktop'
import CatalogMobile from '@/components/CatalogMobile'
import LoadingSpinner from '@/components/LoadingSpinner'
import SearchOrderManagerDialog from '@/components/SearchOrderManagerDialog'

export default {
	name: 'App',
	components: {SearchOrderManagerDialog, LoadingSpinner, CatalogMobile, CatalogDesktop},
	data: () => ({
		loading: true,
		currentPageFromParams: undefined,
    searchOrderId: '',
		errorDialog: {
			show: false,
			text: '',
			url: '',
		}
	}),
	async mounted() {
		this.$bus.$on('network-error', this.handleNetworkError) // handler for fetch errors

		await this.$store.actions.getFilters()

		let query = window.location.search

		if (query && query.length > 1) {
			query = new URLSearchParams(query)

			this.$store.pagination.per_page = this.$http.parseQueryParam(query.get('per_page')) ?? 15

			this.currentPageFromParams = this.$http.parseQueryParam(query.get('page')) ?? 1

			this.$store.pagination.page = this.currentPageFromParams

      		this.$store.isBusinessCustomer =  this.$http.parseQueryParam(query.get('is_business')) ?? false

			this.$store.sortBy = this.$http.parseQueryParam(query.get('sort')) ?? 'priceAsc'

      //we need all utm_ parameters
      query.forEach((value, key) => {
          if(key.includes('UTM_') || key.includes('utm_')) {
            this.$store.utm.push({
              key: key,
              value: value
            });
          }

          if(key.includes('searchOrderId')){
            this.searchOrderId = value
            this.$forceUpdate()
          }
      });

			this.$store.actions.setFiltersFromURLSearchParams(query)

			this.$bus.$on('vehicles-list-updated', (vehicles) => {

				// initially set the page from URL params after the vehicles have loaded
				this.$nextTick(() => {
         	//Google Tag Manager
			const vehicleImpressions = vehicles.map((item, index) => {
				return {
				'id': item['id'],
				'name': item['title'],
				'brand': item['brand'].title,
				'category': item['category'].title,
				'subsidiaryId': item['subsidiary'].id,
				'list': 'Search Results',
				'position': index+1
				}
			});

			window.dataLayer.push({
				'ecommerce': {
				'currencyCode': process.env.VUE_APP_USE_CURRENCY,                       // Local currency is optional.
				'impressions': vehicleImpressions
				}
			});
          //Google Tag Manager End

					if (this.currentPageFromParams) {
						this.$store.pagination.page = this.currentPageFromParams
						this.currentPageFromParams = undefined
					}
				})
			})
		}

		this.loading = false
    this.$nextTick(function() {
      const event = new CustomEvent('catalog-loaded');
      window.dispatchEvent(event);
    })

	},
  methods: {
		handleNetworkError(error) {
			this.errorDialog = {
				show: true,
				text: error.response.message || error.response.statusText,
				url: error.url
			}
		},
		reload() {
			var currentURL = window.location.href;
    		var trimmedURL = currentURL.split('/')[0] + '//' + currentURL.split('/')[2];
    		location.replace(trimmedURL);
		}
	},
}
</script>


<style lang='scss'>
@import 'styles/style.scss';

#catalog-vue-app {
	color: #0A0A14 !important;
}
#catalog-vue-app * {
  box-sizing: border-box;
}

#catalog-container .vue-slider {
  box-sizing: content-box !important;
}

#catalog-container .vue-slider *{
  box-sizing: inherit !important;
}

.font-weight-regular label {
  @extend .font-weight-regular
}

</style>